'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('autofill',
			function() {
				return {
					require: 'ngModel',
					link: function(scope, element, attrs, ngModel) {
						scope.$on('autofill:update',
							function() {
								ngModel.$setViewValue(element.val());
							});
					}
				};
				/* http://stackoverflow.com/questions/14965968/angularjs-browser-autofill-workaround-by-using-a-directive#answer-19854565 */
			});
})();
